export default __webpack_public_path__ + "static/media/shop-n-enjoy.be52b985.svg";